import { render, staticRenderFns } from "./IDate.vue?vue&type=template&id=d5fb66c0&"
import script from "./IDate.vue?vue&type=script&lang=js&"
export * from "./IDate.vue?vue&type=script&lang=js&"
import style0 from "./IDate.vue?vue&type=style&index=0&id=d5fb66c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports